var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccessBigIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_407_15)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 37.5,
    r: 25.5,
    fill: "#E0F8DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1668 26.7767V29C60.1639 34.2114 58.4764 39.2822 55.3561 43.4561C52.2357 47.63 47.8498 50.6835 42.8523 52.1611C37.8548 53.6387 32.5135 53.4613 27.6251 51.6553C22.7367 49.8493 18.5631 46.5114 15.7267 42.1396C12.8902 37.7678 11.543 32.5962 11.8859 27.3961C12.2288 22.1961 14.2434 17.2461 17.6293 13.2846C21.0153 9.32308 25.5911 6.56219 30.6743 5.4137C35.7575 4.26522 41.0758 4.79067 45.836 6.91169",
    stroke: "#57AA43",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.1667 9.66669L36 33.8575L28.75 26.6075",
    stroke: "#57AA43",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_407_15"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 60,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessBigIcon);
export default __webpack_public_path__ + "static/media/SuccessBigIcon.be0b2bc115201e3e87f0371cb310a756.svg";
export { ForwardRef as ReactComponent };